import { useState } from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import QuoteSection from '../components/QuoteSection';
import LightboxModal from '../components/LightboxModal';
import { companyInfo } from '../data/siteData';
import { imageUrl } from '../lib/images';

export default function VinduespartierPage() {
  const [lightboxIndex, setLightboxIndex] = useState(null);

  const images = [
    { src: "/_assets/img-20220901-115952-logo.jpg", title: "Vinduesparti montering" },
    { src: "/_assets/img-20220901-151707-logo.jpg", title: "Specialbygget vinduesparti" },
    { src: "/_assets/img-20240412-161321-logo-0.jpg", title: "Flot lysindfald i bolig" },
  ];

  return (
    <>
      <SEO
        title="Vinduespartier | Hovendals"
        description="Vinduespartier tilpasset din bolig Hos Hovendals designer og monterer vi vinduespartier i høj kvalitet, skræddersyet til din boligs stil og behov. Uanset om du ønsker store glaspartier med maksimal lysindfald eller mere klassiske løsninger, der bevarer husets oprindelige charme, skaber vi et resultat, der forener æstetik, funktionalitet og energieffektivitet."
        ogImage="/_assets/img-20240412-161321-logo.jpg"
      />

      {/* Hero */}
      <section className="relative py-20 bg-slate-900 text-white overflow-hidden">
        <div className="absolute inset-0 z-0 opacity-25">
          <img
            src={imageUrl("/_assets/img-20240412-161321-logo.jpg", "width=1600,quality=80,format=auto")}
            alt="Vinduespartier"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="max-w-3xl space-y-4">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider bg-[#004fa4]/20 text-[#c2ccdf] border border-[#004fa4]/30">
              <i className="fa-sharp fa-solid fa-window-frame" aria-hidden="true"></i>
              <span>Lys & energieffektivitet</span>
            </div>
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white leading-tight">
              Vinduespartier
            </h1>
            <p className="text-base sm:text-lg text-slate-300 leading-relaxed font-normal">
              Skræddersyede løsninger, der forener lysindfald, æstetik, funktionalitet og høj energieffektivitet.
            </p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16 md:py-20 bg-white">
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
            <div className="space-y-6">
              <div>
                <span className="text-xs font-bold uppercase tracking-wider text-[#004fa4]">Tilpasset din bolig</span>
                <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-900 tracking-tight mt-1">
                  Vinduespartier tilpasset din bolig
                </h2>
              </div>
              <p className="text-slate-700 leading-relaxed text-base">
                Hos Hovendals designer og monterer vi vinduespartier i høj kvalitet, skræddersyet til din boligs stil og behov. Uanset om du ønsker store glaspartier med maksimal lysindfald eller mere klassiske løsninger, der bevarer husets oprindelige charme, skaber vi et resultat, der forener æstetik, funktionalitet og energieffektivitet.
              </p>
              <p className="text-slate-700 leading-relaxed text-base">
                Et nyt vinduesparti handler ikke kun om udseende – det er en investering i komfort, indeklima og lavere energiforbrug. Med Hovendals får du en løsning, der både ser godt ud og holder i mange år frem.
              </p>

              <div className="bg-slate-50 p-6 rounded-xl border border-slate-200">
                <h3 className="font-bold text-slate-900 text-sm uppercase tracking-wider mb-3">
                  Vinduespartier, der forener lys, kvalitet og design
                </h3>
                <ul className="space-y-2.5 text-sm text-slate-700 font-medium">
                  <li className="flex items-start gap-2">
                    <i className="fa-sharp fa-solid fa-check text-[#004fa4] mt-1" aria-hidden="true"></i>
                    <span>Vinduespartier i materialer af høj kvalitet – altid tilpasset boligens arkitektur</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="fa-sharp fa-solid fa-check text-[#004fa4] mt-1" aria-hidden="true"></i>
                    <span>Mulighed for både moderne glaspartier og klassiske vinduesløsninger</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="fa-sharp fa-solid fa-check text-[#004fa4] mt-1" aria-hidden="true"></i>
                    <span>Design, der maksimerer lysindfald og fremhæver boligens udtryk</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="fa-sharp fa-solid fa-check text-[#004fa4] mt-1" aria-hidden="true"></i>
                    <span>Fokus på energivenlige materialer og lang levetid</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="fa-sharp fa-solid fa-check text-[#004fa4] mt-1" aria-hidden="true"></i>
                    <span>En investering i komfort, æstetik og fremtidens energieffektivitet</span>
                  </li>
                </ul>
              </div>

              <div className="flex flex-wrap gap-4 pt-2">
                <a
                  href={`tel:${companyInfo.phoneFormatted}`}
                  className="px-6 py-3 rounded-lg bg-[#004fa4] hover:bg-[#183e7f] text-white font-medium text-sm shadow-sm transition-all flex items-center gap-2"
                >
                  <i className="fa-sharp fa-solid fa-phone" aria-hidden="true"></i>
                  <span>Ring: {companyInfo.phone}</span>
                </a>
                <Link
                  to="/kontakt"
                  className="px-6 py-3 rounded-lg bg-slate-900 hover:bg-slate-800 text-white font-bold text-sm transition-all flex items-center gap-2"
                >
                  <i className="fa-sharp fa-solid fa-paper-plane" aria-hidden="true"></i>
                  <span>Få et uforpligtende tilbud</span>
                </Link>
              </div>
            </div>

            <div className="relative rounded-2xl overflow-hidden shadow-xl border-4 border-white bg-slate-100">
              <img
                src={imageUrl("/_assets/img-20240412-161321-logo.jpg", "width=800,quality=85,format=auto")}
                alt="Vinduesparti"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>

          {/* Galleri */}
          <div className="mb-16">
            <h3 className="text-2xl font-bold text-slate-900 mb-2">
              Billeder af vinduespartier
            </h3>
            <p className="text-sm text-slate-600 mb-6">
              Klik på et billede for at se forstørret visning.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-4xl">
              {images.map((img, idx) => (
                <div
                  key={idx}
                  onClick={() => setLightboxIndex(idx)}
                  className="group relative h-64 rounded-xl overflow-hidden bg-slate-100 cursor-pointer shadow-sm hover:shadow-md transition-all"
                >
                  <img
                    src={imageUrl(img.src, "width=600,quality=80,format=auto")}
                    alt={img.title}
                    className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-slate-950/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center text-white">
                    <span className="p-2.5 rounded-full bg-[#143463]/90 text-white text-sm">
                      <i className="fa-sharp fa-solid fa-magnifying-glass-plus" aria-hidden="true"></i>
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Quote Section */}
      <QuoteSection />

      {/* Lightbox modal */}
      <LightboxModal
        images={images}
        currentIndex={lightboxIndex}
        onClose={() => setLightboxIndex(null)}
        onNavigate={(index) => setLightboxIndex(index)}
      />
    </>
  );
}
